import { FormattedMessage, useIntl } from 'react-intl';
import { useBeforeUnload, useBlocker } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import Contact from '../../components/Contact/Contact';
import UnsavedWarningModal from '../../components/UnsavedWarningModal/UnsavedWarningModal';
import bannerImg from '../../assets/images/ubisoft-playtest-contact-banner.webp';
import bannerImgMobile from '../../assets/images/ubisoft-playtest-contact-banner-mobile.webp';
import messages from './messages';
import { setTitle } from '../../utils/generic';

const ContactUs = () => {
  const intl = useIntl();
  const [isFormModified, setFormModified] = useState(false);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isFormModified && currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    setTitle(intl.formatMessage({ ...messages.heading }));
    window.scrollTo(0, 0);
  }, []);

  useBeforeUnload(
    useCallback(
      (event) => {
        if (!isFormModified) return;
        event.preventDefault();
        event.returnValue = true;
      },
      [isFormModified]
    )
  );

  return (
    <div className="page">
      {blocker.state === 'blocked' && (
        <UnsavedWarningModal
          onClose={() => blocker.reset()}
          onClick={() => blocker.proceed()}
        />
      )}
      <div className="page__header">
        <img src={bannerImg} alt="" className="bannerImg bannerDesktop" />
        <img src={bannerImgMobile} alt="" className="bannerImg bannerMobile" />
        <div className="blackOverlay" />
        <div className="content">
          <h1>
            <FormattedMessage {...messages.heading} />
          </h1>
        </div>
      </div>
      <div className="container">
        <Contact setFormModified={setFormModified} />
      </div>
    </div>
  );
};

export default ContactUs;
